/**
 * @generated SignedSource<<2ff42b0c4f0b32ef58f4dfdab24018c9>>
 * @relayHash 50b4e9c9f7cb5e26f7a233aab172101d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cde8e6d55e08a968a422a60db9774d36880affae57e6e9bbcbb6123cfd9cc2fb

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AgentOverviewQuery$variables = {
  cloudId: string;
  helpCenterAri: string;
};
export type AgentOverviewQuery$data = {
  readonly csmAi_getAiHubByHelpCenterAri: {
    readonly __typename: "CsmAiHub";
    readonly agents: ReadonlyArray<{
      readonly versions?: {
        readonly nodes: ReadonlyArray<{
          readonly versionType: string | null;
        }>;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"multiVersionAgentSummary_AtlassianCsmAgentOverview">;
    }> | null;
    readonly id: string;
  } | {
    readonly __typename: "QueryError";
    readonly extensions: ReadonlyArray<{
      readonly errorType: string | null;
    }> | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly customerService: {
    readonly brandingByEntityType: {
      readonly __typename: "CustomerServiceBranding";
      readonly icon: {
        readonly url: AGG$URL | null;
      } | null;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null;
  } | null;
};
export type AgentOverviewQuery = {
  response: AgentOverviewQuery$data;
  variables: AgentOverviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "helpCenterAri"
},
v2 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 2
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "versionType"
},
v7 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v8 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v9 = [
  {
    "kind": "Literal",
    "name": "entityType",
    "value": "CUSTOMER_HUB"
  },
  {
    "kind": "Variable",
    "name": "helpCenterId",
    "variableName": "helpCenterAri"
  }
],
v10 = {
  "concreteType": "CustomerServiceBrandingIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "url"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "AgentOverviewQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "name": "agents",
                "plural": true,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "multiVersionAgentSummary_AtlassianCsmAgentOverview"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "args": (v5/*: any*/),
                        "concreteType": "CsmAiAgentVersionConnection",
                        "kind": "LinkedField",
                        "name": "versions",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "RequiredField",
                            "field": {
                              "concreteType": "CsmAiAgentVersion",
                              "kind": "LinkedField",
                              "name": "nodes",
                              "plural": true,
                              "selections": [
                                (v6/*: any*/)
                              ]
                            },
                            "action": "THROW"
                          }
                        ],
                        "storageKey": "versions(first:2)"
                      }
                    ],
                    "type": "CsmAiMultiVersionAgent"
                  }
                ]
              }
            ],
            "type": "CsmAiHub"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": true,
                "selections": [
                  (v7/*: any*/)
                ]
              }
            ],
            "type": "QueryError"
          }
        ]
      },
      {
        "args": (v8/*: any*/),
        "concreteType": "CustomerServiceQueryApi",
        "kind": "LinkedField",
        "name": "customerService",
        "plural": false,
        "selections": [
          {
            "args": (v9/*: any*/),
            "kind": "LinkedField",
            "name": "brandingByEntityType",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v10/*: any*/)
                ],
                "type": "CustomerServiceBranding"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AgentOverviewQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "name": "agents",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isCsmAiMultiVersionAgentResult"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "agentId"
                      },
                      {
                        "args": (v5/*: any*/),
                        "concreteType": "CsmAiAgentVersionConnection",
                        "kind": "LinkedField",
                        "name": "versions",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "CsmAiAgentVersion",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "versionNumber"
                              },
                              (v6/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "agentIdentityConfig",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "name"
                                      },
                                      (v4/*: any*/)
                                    ],
                                    "type": "CsmAiAgentIdentity"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "message"
                                      }
                                    ],
                                    "type": "QueryError"
                                  }
                                ]
                              }
                            ]
                          }
                        ],
                        "storageKey": "versions(first:2)"
                      }
                    ],
                    "type": "CsmAiMultiVersionAgent"
                  }
                ]
              }
            ],
            "type": "CsmAiHub"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v7/*: any*/)
                ]
              }
            ],
            "type": "QueryError"
          }
        ]
      },
      {
        "args": (v8/*: any*/),
        "concreteType": "CustomerServiceQueryApi",
        "kind": "LinkedField",
        "name": "customerService",
        "plural": false,
        "selections": [
          {
            "args": (v9/*: any*/),
            "kind": "LinkedField",
            "name": "brandingByEntityType",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v10/*: any*/),
                  (v4/*: any*/)
                ],
                "type": "CustomerServiceBranding"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "cde8e6d55e08a968a422a60db9774d36880affae57e6e9bbcbb6123cfd9cc2fb",
    "metadata": {},
    "name": "AgentOverviewQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0e67e8e175f974c8eae419955c918ad9";

export default node;
